import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { errorHandlerFactory } from './services/sentry.errorhandler';

import 'hammerjs';

import { registerLocaleData } from '@angular/common';

import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';

import { SecurityService } from './services/security.service';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { RouteReuseStrategy } from '@angular/router';

let browserLocale = 'en-GB';

switch (navigator.language) {
  case 'en-US':
    browserLocale = navigator.language;
    break;
  case 'it-IT':
    registerLocaleData(localeIt, 'it-IT');
    browserLocale = navigator.language;
    break;
  default:
    registerLocaleData(localeEn, 'en-GB');
    browserLocale = 'en-GB';
    break;
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: browserLocale },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useFactory: errorHandlerFactory },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
